var _path, _path2, _mask, _rect, _path3, _mask2, _rect2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 74,
    viewBox: "0 0 73 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4437 1H4.55634C2.31608 1 0.5 2.81608 0.5 5.05634V68.9437C0.5 71.1839 2.31608 73 4.55634 73H68.4437C70.6839 73 72.5 71.1839 72.5 68.9437V5.05634C72.5 2.81608 70.6839 1 68.4437 1Z",
    stroke: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 57H11C10.7239 57 10.5 57.2239 10.5 57.5C10.5 57.7761 10.7239 58 11 58H62C62.2761 58 62.5 57.7761 62.5 57.5C62.5 57.2239 62.2761 57 62 57Z",
    fill: "#D9D9D9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_46415_249806",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 15,
    width: 14,
    height: 14,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 15,
    width: 14,
    height: 14,
    rx: 2,
    stroke: "#4D4D4D",
    strokeWidth: 5,
    mask: "url(#path-3-inside-1_46415_249806)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 22H52.5",
    stroke: "#4D4D4D",
    strokeWidth: 2.7,
    strokeLinecap: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_46415_249806",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 33,
    width: 14,
    height: 14,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 33,
    width: 14,
    height: 14,
    rx: 2,
    stroke: "#4D4D4D",
    strokeWidth: 5,
    mask: "url(#path-5-inside-2_46415_249806)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 40H52.5",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListInactiveIcon);
export default __webpack_public_path__ + "static/media/list-inactive-icon.da93a84e1b8ce331ffaa99d1b904cbef.svg";
export { ForwardRef as ReactComponent };